import http from '@/api/common'

export default {
  getDataSchema(name) {
    return http.get(`dashboard/DashboardDataSchema?name=${name}`)
  },
  getChoices(data) {
    return http.get(`dashboard/DashboardSummaryChoices?startDate=${data.startDate}&endDate=${data.endDate}&category=${data.category}`)
  },
  downloadRequestStatistics(data) {
    console.log('Download Request Statistics', data)
    return http.post('dashboard/ExportServiceRequestStatistics', data)
  },
  downloadDeviceStatistics(data) {
    console.log('Download Device Statistics', data)
    return http.post('dashboard/ExportDeviceStatistics', data)
  },
  downloadActivationCardStatistics(data) {
    console.log('Download Activation Card Statistics', data)
    return http.post('dashboard/ExportActivationCardStatistics', data)
  },
  downloadBusinessAccountInfo(data) {
    console.log('Download Business Accounts Informations', data)
    return http.post('dashboard/ExportBusinessAccountSetup', data)
  },
  downloadDeviceShipments(data) {
    console.log('Download Device Shipments', data)
    return http.post('dashboard/ExportDeviceShipment', data)
  },
  downloadRequests(data) {
    return http.get(`dashboard/ExportServiceRequests?startDate=${data.startDate}&endDate=${data.endDate}`)
  },
  downloadRequestsAdhoc(data) {
    return http.post('dashboard/ExportServiceRequestsAdhoc', data)
  },
  getQueryTemplates() {
    return http.get('dashboard/DashboardDataTemplates')
  },
  saveQueryTemplate(data) {
    return http.post('dashboard/DashboardDataTemplateSave', data)
  },
  removeQueryTemplate(data) {
    return http.post('dashboard/DashboardDataTemplateRemove', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/dashboard.js